// extracted by mini-css-extract-plugin
module.exports = {"section":"section_section__2yG9p","title":"section_title__-7sFp","title-container":"section_title-container__1nFWT","body":"section_body__HYSMv","warning":"section_warning__3JvN8"};